export default "__VITE_ASSET__DMd_huxQ__"